import AddHouse from '../../components/AddHouse'

export const AddHousePage =()=><AddHouse/>

export default AddHousePage